import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { CategoryParams, CategoryWithArticlesGetError } from '../model/categoryModel';
import Accordion from '../../../components/Accordion';
import Breadcrumbs from '../../../components/Breadcrumbs';
import * as BreadcrumbsModel from '../../../shared/model/commonModel';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import { PANEL_VIEW } from '../../../components/SearchPanel/enum/searchPanelProps';
import PageView from '../../../components/PageView';
import Button from '../../../components/form/elements/Button';
import { BUTTON_VARIANT } from '../../../components/form/enum/formProps';
import { ROUTES } from '../../../core/router/routes';
import { useGetCategoryTreesQuery, useGetCategoryWithArticlesQuery } from '../api/categoryApi';
import { setBreadcrumbs } from '../../../shared/redux/commonSlice';
import { API_STATUS_CODE } from '../../../core/enums/apiStatusCode';

import './categoryArticle.scss';

const CategoryArticle: React.FC = () => {
  const params = useParams<CategoryParams>();
  const dispatch = useDispatch();
  const history = useHistory();
  const { show, hide } = useMainProgressContext();
  const {
    categoryWithArticlesForAccordion,
    isSuccess: isSuccessCategoryWithArticles,
    isLoading: isLoadingCategoryWithArticles,
    isError: isErrorCategoryWithArticles,
    error: errorCategoryWithArticles,
  } = useGetCategoryWithArticlesQuery(
    {
      id: params.id,
    },
    {
      selectFromResult: (result) => {
        return {
          ...result,
          categoryWithArticlesForAccordion:
            result.data?.map((category) => {
              return {
                title: category.name,
                details: category.articles.map((article) => {
                  return {
                    to: ROUTES.ARTICLE.SHOW.replace(':id', article.id as unknown as string),
                    label: article.name,
                  };
                }),
              };
            }) || [],
        };
      },
    },
  );
  const {
    data: categoryTrees,
    isSuccess: isSuccessCategoryTrees,
    isLoading: isLoadingCategoryTrees,
  } = useGetCategoryTreesQuery({
    id: params.id,
  });

  useEffect(() => {
    if (isSuccessCategoryTrees && isSuccessCategoryWithArticles) {
      let breadcrumbs: BreadcrumbsModel.Breadcrumbs[] = [];

      categoryTrees.forEach((category) => {
        if (category.parent) {
          breadcrumbs.push({
            label: category.name,
            to:
              parseInt(params.id!) !== category.id
                ? ROUTES.CATEGORY.ARTICLE.replace(':id', category.id as unknown as string)
                : null,
          });
        }
      });

      dispatch(setBreadcrumbs(breadcrumbs));

      hide();
    }
  }, [isSuccessCategoryTrees, isSuccessCategoryWithArticles, categoryTrees]);

  useEffect(() => {
    if (isLoadingCategoryWithArticles && isLoadingCategoryTrees) {
      show();
    }
  }, [isLoadingCategoryWithArticles, isLoadingCategoryTrees]);

  useEffect(() => {
    if (isErrorCategoryWithArticles) {
      const error = errorCategoryWithArticles as CategoryWithArticlesGetError;

      switch (error.status) {
        case API_STATUS_CODE.NOT_FOUND:
          history.push(ROUTES.ERROR_404);
          break;
      }
    }
  }, [isErrorCategoryWithArticles]);

  return (
    <PageView
      view={PANEL_VIEW.FULL}
      className="CategoryArticle small-padding"
      showMoreCategoryInCategory={true}
      showMostSearched={false}
      categoryId={params.id}
    >
      <Button
        variant={BUTTON_VARIANT.TEXT}
        text="button.return"
        onClick={() => history.goBack()}
        startIcon={<ChevronLeftIcon />}
      />
      <Breadcrumbs />
      <section className="CategoryArticle-Accordion-Wrapper">
        <Accordion
          className="CategoryArticle-Accordion"
          expandIcon={null}
          expanded={true}
          data={categoryWithArticlesForAccordion}
        />
      </section>
    </PageView>
  );
};

export default CategoryArticle;
